<template>
  <div style="padding-top: 10vh">
    <common-header :menu="{}"/>
    <h1>お問い合わせ</h1>

    <div v-if="!sent">
      <div class="input-section">
        <div class="input-title">
          返信先<span style="font-size: 80%">(任意, 記入頂いても必ず返信できるとは限りません)</span>
        </div>
        <input type="text" v-model="address" placeholder="メールアドレスなど" class="input"/>
      </div>
      <div class="input-section">
        <div class="input-title">お問い合わせ内容</div>
        <textarea v-model="message" placeholder="お問い合わせ内容" class="input"></textarea>
        <div>
          {{currentLength}}/{{maxMessageLength}}文字
        </div>
      </div>
      <div>
        <ul class="errors">
          <li v-for="error in errorMessages">{{error}}</li>
        </ul>
        <basic-button label="送信" @click="send" />
      </div>
    </div>

    <div v-if="sent">
      <h3>以下の内容で送信しました</h3>
      <div class="post-message">
        {{message}}
      </div>
    </div>

    <common-footer :show-footer="false" :menu="{home:true}"/>
  </div>
</template>

<script>
import { getFirestore, collection, getDocs, doc, setDoc, addDoc } from "firebase/firestore";
import BasicButton from "./common/BasicButton";
import CommonHeader from "./CommonHeader";
import CommonFooter from "./CommonFooter";
export default {
  components: {CommonFooter, CommonHeader, BasicButton},
  mounted() {
    // setTimeout(() => this.send(), 10)
  },
  data() {
    return {
      message: '',
      address: '',
      maxMessageLength: 1000,
      errorMessages: [],
      sent: false,
    }
  },
  computed: {
    currentLength() {
      return this.message.length
    },
  },
  methods: {
    validate() {
      this.errorMessages = []

      if (this.currentLength === 0) {
        this.errorMessages.push('お問い合わせが入力されていません')
      }
      if (this.currentLength > this.maxMessageLength) {
        this.errorMessages.push(`メッセージは${this.maxMessageLength}文字以内でお願いします`)
      }
    },
    async send() {
      this.validate()
      if (this.errorMessages.length > 0) {
        return
      }

      const db = getFirestore(fireBaseApp);
      const docRef = await addDoc(collection(db, "contact"), {
        address: this.address,
        message: this.message,
        time: `${new Date().toString()}`,
      })

      this.sent = true
    }
  },
  name: "Contact",
}
</script>

<style scoped>
h1 {
  color: #e74a23;
}
.input-section {
  width: 80vw;
  max-width: 50vh;
  margin: 4vh auto;
}
.input-title {
  margin: 1vh;
  color: #e74a23;
  font-weight: bold;
}
.input {
  width: 100%;
  border: 1px solid #e74a23;
  padding: 1vh;
  border-radius: 0.5vh;
}
.post-message {
  border: 1px solid #e74a23;
  width: 80vw;
  max-width: 50vh;
  border-radius: 0.5vh;
  margin: 0 auto;
  padding: 1vh;
  text-align: left;
}
.errors {
  width: 80vw;
  max-width: 50vh;
  text-align: left;
  margin: 0 auto;
  color: #dd1111;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue